// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2-f60","vLegacy":"SelectSecondary_vLegacy__1q8pZ","error":"SelectSecondary_error__3GV5k","disabled":"SelectSecondary_disabled__33MZ1"};